import { Entity, Periodicity } from '@ecosystem/newron-core/types';
import { Market, TimeFrameOption } from '../types';
import { entityToTimeFrame } from './timeFrame';

export const MONTH_OPTIONS = [
  { value: '1', label: 'January to date' },
  { value: '2', label: 'February to date' },
  { value: '3', label: 'March to date' },
  { value: '4', label: 'April to date' },
  { value: '5', label: 'May to date' },
  { value: '6', label: 'June to date' },
  { value: '7', label: 'July to date' },
  { value: '8', label: 'August to date' },
  { value: '9', label: 'September to date' },
  { value: '10', label: 'October to date' },
  { value: '11', label: 'November to date' },
  { value: '12', label: 'December to date' },
];

export const getSelectedMarkets = settings => {
  const cells = settings['cell'].values.map(c => c.value);
  const allMarkets: Market[] = settings['openMarkets'].definition.selection.options.filter(
    opt => typeof opt !== 'string'
  ) as Market[];
  const selectedMarkets = allMarkets.filter(m => cells.includes(m.value));
  return selectedMarkets;
};

export const getTimeFrameOptions = (
  settings,
  selectedContext: string,
  selectedMarkets: Market[]
): TimeFrameOption[] => {
  const earliestWeekly = Math.min(
    ...selectedMarkets.map(m => m.periods.find(p => p.periodicity === Periodicity.Weekly)?.sequence || -1)
  );
  const earliestMonthly = Math.min(
    ...selectedMarkets.map(m => m.periods.find(p => p.periodicity === Periodicity.Monthly)?.sequence || -1)
  );

  const periodOptions = settings[selectedContext].definition.selection.options.filter(
    o => typeof o !== 'string'
  ) as Entity[];

  const timeFrameOptions: TimeFrameOption[] = periodOptions.map(po => {
    const timeFrame = entityToTimeFrame(po);
    return {
      ...timeFrame,
      availableOnAll:
        Number(timeFrame.endSequence) <=
        (timeFrame.periodicity === Periodicity.Weekly ? earliestWeekly : earliestMonthly),
    };
  });
  return timeFrameOptions;
};
